import Button, { ConfirmButton, CancelButton } from 'components/ui/Button';
import Text from 'admin-components/components/Text';
import styled from 'styled-components';

import { MEDIA_QUERIES } from 'constants/breakpoints';
import { colours } from 'themes/default';

export const StyledText = styled(Text)`
  display: block;
  margin-bottom: 1em;
`;

export const PassengerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
`;

export const PassengerActionItem = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 0 1 auto;
  max-width: 100%;

  @media ${MEDIA_QUERIES.isDesktop} {
    flex: 0 1 auto;
    max-width: 320px;
  }
`;

export const EditButton = styled(Button)`
  width: 100%;
  margin: 0;
  text-align: center;
  white-space: normal;

  @media ${MEDIA_QUERIES.isDesktop} {
    width: auto;
    max-width: 320px;
  }

  div {
    margin: 0 auto;
  }
`;

export const SaveButton = styled(ConfirmButton)`
  width: 100%;
  text-align: center;

  div {
    margin: 0 auto;
  }
`;

export const ExitButton = styled(CancelButton)`
  width: 100%;
  text-align: center;
`;

export const DeleteButton = styled(Button)`
  width: auto;
  text-align: center;
`;

export const ApplyToAllLabel = styled.span`
  text-decoration: underline;
  text-transform: lowercase;
  font-size: 12px;
  padding-left: 8px;
  margin-left: auto;
  cursor: pointer;
  color: ${colours.Core.SecondaryPlum};
`;

export const StyledTableInputWrapper = styled.div`
  display: flex;
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
  color: ${({ isTravelDocumentRequired, hasTravelDocumentBeenProvided }) => {
    if (!isTravelDocumentRequired) {
      return colours.Messaging.WarningOrange;
    }

    switch (hasTravelDocumentBeenProvided) {
      case true:
        return colours.Messaging.SuccessGreen;
      case false:
        return colours.Messaging.ErrorRed;
      default:
        return colours.Messaging.WarningOrange;
    }
  }};
`;
export const StyledTableInputHidden = styled.input`
  display: none;
`;

export const StyledTableInput = styled.input`
  outline: none;
  width: 100%;
  background-color: ${({ disabled }) => (disabled ? 'transparent' : colours.Greyscale.White)};
  border-style: solid;
  border-width: 1px;
  border-color: ${({ disabled = false, isInvalid }) => {
    if (disabled) {
      return 'transparent';
    }

    if (!disabled && isInvalid) {
      return colours.Messaging.ErrorRed;
    }

    return colours.Greyscale.SilverGrey;
  }};
`;

export const StyledTableInputError = styled.div`
  color: red;
  font-size: 11px;
  display: ${({ disabled }) => (disabled ? 'none' : 'block')};
  position: absolute;
  top: 70%;
`;
export const SmallText = styled.span`
  margin-bottom: 0;
  padding-right: 3px;
  padding-top: 1px;
  font-size: 12px;
`;

export const DependantTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
